import { useToast } from '@dc-shared-web/components'
import { useSvcCrunchesContext } from '@dc-shared-web/providers/SvcCrunchesProvider'
import { AxiosInstance } from 'axios'
import { useMutation, useQueryClient } from 'react-query'

type StartJobResult = {
  message: string
}

const startJobGenPlaybook = async (
  apiClient: AxiosInstance,
  docGuid: string
): Promise<StartJobResult> => {
  const { data } = await apiClient.post('/api/jobs/job-gen-playbook', {
    doc_guid: docGuid,
  })

  return data
}

export const useStartJobGenPlaybook = (params?: {
  onSuccess?: () => void
  onError?: () => void
}) => {
  const apiClient = useSvcCrunchesContext()
  const queryClient = useQueryClient()
  const { toast } = useToast()

  return useMutation(
    (mutParams: string) => startJobGenPlaybook(apiClient, mutParams),
    {
      onSuccess: async () => {
        toast({
          variant: 'success',
          title: 'GenAI Playbook Job has been restarted',
          description:
            'This process takes some time to complete. Please, check back later.',
        })

        await queryClient.invalidateQueries({
          queryKey: ['processingDocument'],
        })

        params?.onSuccess?.()
      },
      onError: () => {
        toast({
          variant: 'error',
          title: 'Error restarting GenAI Playbook Job',
          description: 'If the issue persists, please contact support.',
        })

        params?.onError?.()
      },
    }
  )
}
